import * as React from "react"
import Svg, { Path } from "react-native-svg"

function SuccessIcon(props) {
    return (
        <Svg
            xmlns="http://www.w3.org/2000/svg"
            width={56}
            height={56}
            viewBox="0 0 56 56"
            fill="none"
            {...props}
        >
            <Path
                d="M26.16 0h3.345c.244 0 .48.062.721.092 1.74.309 3.497.478 5.207.925 3.584.924 6.801 2.571 9.711 4.832.48.373.865.85 1.195 1.36.678 1.063 1.418 2.08 2.018 3.19 2.08 3.85 3.097 7.994 3.282 12.338.107 2.434-.185 4.837-.725 7.21-.616 2.71-1.648 5.237-3.019 7.64a28.028 28.028 0 01-6.331 7.518 28.294 28.294 0 01-6.763 4.174 27.263 27.263 0 01-10.213 2.311c-1.602.046-3.235-.108-4.837-.293-4.005-.477-7.702-1.833-11.091-4.036l-1.371-.901a6.252 6.252 0 01-1.433-1.286C.634 38.11-1.138 30.347.711 21.89 3.22 10.46 12.418 2.033 24.018.293c.709-.108 1.417-.2 2.141-.293zm-2.976 32.776a.582.582 0 01-.86-.026c-1.603-1.817-3.205-3.635-4.822-5.438-1.356-1.51-3.743-1.494-4.868.031-.909 1.202-.801 2.896.293 4.113 1.525 1.71 3.065 3.42 4.59 5.13 1.079 1.186 2.126 2.403 3.25 3.543.94.955 2.404 1.078 3.513.339.493-.324.909-.77 1.325-1.217 4.436-4.852 8.873-9.72 13.294-14.573 1.432-1.571 2.88-3.142 4.298-4.729.862-.97 1.017-2.095.508-3.25-.477-1.094-1.386-1.726-2.603-1.772-1.094-.03-1.957.462-2.68 1.248-4.838 5.253-9.66 10.521-14.496 15.774-.232.271-.476.543-.742.827z"
                fill="#38B000"
            />
            <Path
                d="M55.998 29.963c-.108.77-.2 1.54-.324 2.31-.862 5.546-3.188 10.398-6.947 14.542-4.19 4.606-9.35 7.58-15.466 8.673-8.781 1.571-16.684-.462-23.523-6.254-1.202-1.017-2.203-2.265-3.297-3.405.724.478 1.448.955 2.188 1.433 3.389 2.187 7.086 3.558 11.09 4.036 1.603.185 3.236.339 4.838.293 3.543-.108 6.963-.863 10.213-2.311a28.293 28.293 0 006.763-4.175 27.748 27.748 0 006.331-7.517c1.387-2.403 2.419-4.945 3.02-7.64.539-2.373.816-4.776.724-7.21-.185-4.36-1.202-8.503-3.282-12.34-.6-1.093-1.34-2.125-2.018-3.188-.17-.262-.323-.524-.477-.786 1.694 1.294 3.127 2.835 4.42 4.514 2.912 3.79 4.715 8.056 5.423 12.786.108.77.216 1.54.324 2.295v3.944z"
                fill="#34A300"
            />
        </Svg>
    )
}

export default SuccessIcon
